import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import DatasetDefinitionsContext from 'contexts/DatasetDefinitionsContext';
import FleetOpsMarkdown from 'components/DriverAX/screens/BonusConfigurationScreen/FleetOpsMarkdown';
import useBonusExplainerMarkdown from 'components/DriverAX/screens/BonusConfigurationScreen/useBonusExplainerMarkdown';
import Loading from 'components/Loading/Loading';
import useCurrentAccountId from 'hooks/useCurrentAccountId';
import Typography from 'kingpin/atoms/Typography';
import { TopBarDiv } from 'screens/V3/Workspace/screens/UsersScreen/WorkspaceUsersScreen';

const PageDiv = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  background-color: var(--color-bg-primary);
`;

const ContentDiv = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 32px 200px;
`;

// Opened in a new tab from staff bonus configuration screens so the program's
// rules can be read alongside the config.
const BonusRules = () => {
  // This screen isn't mounted under a :bonusProgramId <Route>, so derive the id
  // from the path rather than useParams (which would be empty here).
  const { pathname } = useLocation();
  const bonusProgramId =
    pathname.split('/bonus-rules/')[1]?.split(/[?/]/)[0] ?? '';
  const accountId = useCurrentAccountId();
  const { bonusPrograms } = useContext(DatasetDefinitionsContext);
  const bonusProgram = bonusPrograms.find((p) => p.id === bonusProgramId);
  const { markdown, isLoading } = useBonusExplainerMarkdown({
    accountId,
    bonusProgramId,
  });

  return (
    <PageDiv>
      <TopBarDiv>
        <Typography.Header type={'H3'}>
          {bonusProgram ? `${bonusProgram.name} – Rules` : 'Bonus Rules'}
        </Typography.Header>
      </TopBarDiv>
      <ContentDiv>
        {isLoading && <Loading />}
        {!isLoading && markdown !== undefined && (
          <FleetOpsMarkdown markdown={markdown} />
        )}
        {!isLoading && markdown === undefined && (
          <Typography.Body type={'Body 13'}>
            No rules document has been uploaded for this program.
          </Typography.Body>
        )}
      </ContentDiv>
    </PageDiv>
  );
};

export default BonusRules;
